export const URI_BOOKINGS = 'bookings';
export const URI_BOOKING = 'booking';
export const URI_BOOKING_TARGETS = 'targets';
export const URI_BOOKING_TEMPLATES = 'templates';
export const URI_BOOKING_SETTINGS = 'settings';
